import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { equationStringToSimplifiedParsedString } from '~/bootcamp/Activities/Algebra/Algebra.utils'

const VARIABLES = ['a', 'b', 'c', 'd', 'x', 'y', 'z', 'ab', 'bc', 'bd', 'cd', 'ax', 'by', 'cz', 'xy', 'yz']

export const RANGE_DATA: RangeDataModel = {
  1: {
    minInteger: 2,
    maxInteger: 10,
    minVariableIndex: 0,
    maxVariableIndex: 6,
    minCoefficient: 1,
    maxCoefficient: 10,
    integerCount: 1,
    maxHistoryLength: 7,
  },
  2: {
    minInteger: -10,
    maxInteger: 10,
    minVariableIndex: 7,
    maxVariableIndex: VARIABLES.length - 1,
    minCoefficient: -10,
    maxCoefficient: 10,
    integerCount: 1,
    maxHistoryLength: 7,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minInteger: number
  maxInteger: number
  minVariableIndex: number
  maxVariableIndex: number
  integerCount: number
  minCoefficient: number
  maxCoefficient: number
  maxHistoryLength: number
}

export interface MultCoefficient2ActivityDataModel {
  variable: string
  integers: number[]
  coefficient: number
  answer: number
  equationString: string
  maxHistoryLength: number
}

export function generateMultCoefficient2ActivityData(
  difficultyLevel: number,
  taskHistory: string[],
): MultCoefficient2ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel > 2 ? 2 : difficultyLevel]
  const variable = VARIABLES[getRandomInt(range.minVariableIndex, range.maxVariableIndex)]
  const coefficient = getRandomInt(range.minCoefficient, range.maxCoefficient, [0])
  const integers: number[] = []
  let answer = coefficient
  // eslint-disable-next-line
  for (let i = 0; i < range.integerCount; i++) {
    integers[i] = getRandomInt(range.minInteger, range.maxInteger, [0, 1, -1, ...integers])
    answer *= integers[i]
  }
  let equationString = ''
  integers.forEach((integer) => {
    equationString += `${integer} * `
  })
  if (coefficient > 1) equationString += coefficient
  equationString += variable
  if (taskHistory.includes(equationString)) {
    return generateMultCoefficient2ActivityData(difficultyLevel, taskHistory)
  }
  return { variable, integers, coefficient, answer, equationString, maxHistoryLength: range.maxHistoryLength }
}

export function checkMultCoefficient2Answer(
  answer: number,
  variable: string,
  equationString: string,
  userAnswer: string,
): boolean {
  if (equationString.replaceAll(' ', '') === userAnswer.replaceAll(' ', '')) {
    return false
  }
  return (
    equationStringToSimplifiedParsedString(answer + variable) === equationStringToSimplifiedParsedString(userAnswer)
  )
}
